module.exports = __webpack_public_path__ + "img/img7.260e06fe.png";